import * as React from 'react';
import { Form, FieldArray, formValueSelector, reduxForm, Field } from 'redux-form';
import { flow, get } from 'lodash';
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import {IPolicyApplication, IProduct} from '../../../../data/api/models';
import FaChevronRight from 'react-icons/fa/chevron-right';

import TravellersInfo from './components/TravellersInfo';
import {connect} from 'react-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {bindActionCreators} from 'redux';
import {IStore} from '../../../../redux/IStore';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteState} from '../../../../services/quote/models';
import Signpost from '../SchemeChoice/components/Signpost';
import {isRequired, isValidCarReg} from '../../../../util/validators';
import FieldFormControl from '../../../../components/FieldFormControl';

interface IPersonalDetailsProps {
  onBack: () => void;
  handleSubmit: () => void;
  change: any;
  product: IProduct;
  i18n: II18nMessages;
  groupType: string;
  channel: any;
  tripType: string;
  quote: IQuoteState;
}

class PersonalDetails extends React.Component<IPersonalDetailsProps> {
  private unableToProvideQuoteMessage = () => {
    const { channel, quote } = this.props;

    if (quote.isCalculating || quote.isSignposting) {
        return;
    }

    if (quote.signpost) {
        return (
            <div style={{ padding: '20px', backgroundColor: '#f6f6f6' }}>
                <Signpost signpost={quote.signpost} channel={channel}/>
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', backgroundColor: '#f6f6f6' }}>
            <span>
              Sorry, we are not able to complete your quotation online as we need a few more details.<br /><br />
              Simply call our UK-based specialist customer service team on {channel.phone} quoting
              {' '}<strong>{quote.application.quoteReference}</strong> who will discuss your requirements with you.
              <br /><br />We are open Monday to Friday Monday – Friday 8am – 6pm, closed Bank Holidays.
            </span>
        </div>
    );
  }

  public render() {
    const { handleSubmit, onBack, product, i18n, groupType, channel, quote } = this.props;
    const errors = get(quote, 'application.premiums[0].errors.length', 0) > 0;
    const normaliseReg = (value) => (value) && value.toUpperCase();

    return (
      <div>
        {!errors ? (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <div className="steps-container">
              <div className="section-title">
                <h1>Personal details</h1>
              </div>
              <strong>Please complete all fields below.</strong>
              <FieldArray
                name="travellers"
                i18n={i18n}
                channel={channel}
                product={product}
                test={'test'}
                component={TravellersInfo}
                groupType={groupType}
                change={this.props.change}
              />
              {quote.signpost && (
                <div>
                    <Signpost signpost={quote.signpost} channel={channel}/>
                </div>
              )}
                {channel.key === 'eurp-b2c' && (
                <div className="section">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Vehicle Registration Number:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name={'vehicleReg'}
                                type="text"
                                placeholder="Vehicle Registration Number"
                                component={FieldFormControl}
                                validate={[isRequired, isValidCarReg]}
                                normalize={normaliseReg}
                            />
                        </Col>
                    </Row>
                </div>
                )}
              <div className="btn-bar margin-top">
                <Button
                  bsStyle="primary"
                  type="submit"
                  className="pull-right"
                   // disabled={submitting || (submitFailed && !valid)}
                >
                    Continue
                  <FaChevronRight/>
                </Button>
                <Button type="button" className="btn-back" onClick={onBack}>
                  Back
                </Button>
              </div>

            </div>
          </Form>
        ) : (
            <div>
                {this.unableToProvideQuoteMessage()}
            </div>
        )}
      </div>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: IPersonalDetailsProps,
    ) => {
      if (! previousValues) {
        previousValues = values;
        return;
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const residency = selector(state, 'residency');
      const quotationTypes = selector(state, 'quotationTypes');
      const vehicleReg = selector(state, 'vehicleReg');

      return {
        tripType,
        quotationTypes,
        residency,
        region,
        maxTripDuration,
        groupType,
        startDate,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        vehicleReg,
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(PersonalDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/PersonalDetails/index.tsx